export default __webpack_public_path__ + "static/media/ProfilePic.31274b71.jpg";